import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "execution-log__node-chunk"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogEntryFlex = _resolveComponent("LogEntryFlex")!
  const _component_DynamicScrollerItem = _resolveComponent("DynamicScrollerItem")!
  const _component_DynamicScroller = _resolveComponent("DynamicScroller")!

  return (_ctx.entryOutputs && _ctx.entryOutputs.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_component_DynamicScroller, {
          key: _ctx.nodeChunkKey,
          ref: "scroller",
          items: _ctx.entryOutputs,
          "min-item-size": 2,
          class: "scroller execution-log__chunk",
          "key-field": "lineNumber"
        }, {
          default: _withCtx(({ item, index, active }) => [
            _createVNode(_component_DynamicScrollerItem, {
              item: item,
              "data-index": index,
              active: active,
              "size-dependencies": [item.log, item.logHtml],
              "emit-resize": _ctx.emitResize,
              onResize: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToLine()))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_LogEntryFlex, {
                  key: index,
                  "event-bus": _ctx.eventBus,
                  title: _ctx.entryTitle(item),
                  selected: _ctx.selectedLine === index + 1,
                  config: _ctx.opts,
                  "prev-entry": index > 0 ? _ctx.entryOutputs[index - 1] : null,
                  "log-entry": item,
                  onLineSelect: _ctx.onSelectLine
                }, null, 8, ["event-bus", "title", "selected", "config", "prev-entry", "log-entry", "onLineSelect"]))
              ]),
              _: 2
            }, 1032, ["item", "data-index", "active", "size-dependencies", "emit-resize"])
          ]),
          _: 1
        }, 8, ["items"]))
      ]))
    : _createCommentVNode("", true)
}